<template>
  <div class="mb-5">
    <div v-if="!loading">
      <div v-if="showResultsModal && sites.all.length >= 1">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Résultats de la recherche</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Fermer"
                    >
                      <span aria-hidden="true" @click="showResultsModal = false"
                        >&times;</span
                      >
                    </button>
                  </div>
                  <div class="modal-body">
                    Nombre de sites :
                    <ul>
                      <li>trouvés : {{ sites.all.length }}</li>
                      <li v-if="sites.geolocalized.length >= 1">
                        géolocalisés : {{ sites.geolocalized.length }}
                      </li>
                      <li v-if="sites.notFound.length >= 1">
                        non géolocalisables : {{ sites.notFound.length }}
                        <b-row class="text-center" style="width: 100%">
                          <b-button
                            class="mt-2"
                            v-b-toggle.collapse-sites-not-found
                            >Voir les sites non géolocalisés</b-button
                          >
                          <b-collapse id="collapse-sites-not-found">
                            <b-card>
                              <b-table
                                :items="sites.notFound"
                                :current-page="notFoundTable.currentPage"
                                :fields="notFoundTable.fields"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :per-page="notFoundTable.perPage"
                              >
                                <template v-slot:cell(salesforceLink)="row">
                                  <b-button
                                    size="sm"
                                    @click="goToSalesforceSite(row)"
                                  >
                                    Vers Salesforce
                                  </b-button>
                                </template>
                              </b-table>
                              <b-pagination
                                style="width: 100%"
                                v-model="notFoundTable.currentPage"
                                :total-rows="sites.notFound.length"
                                :per-page="notFoundTable.perPage"
                                align="fill"
                                size="sm"
                                class="text-center"
                              ></b-pagination>
                            </b-card>
                          </b-collapse>
                        </b-row>
                      </li>
                    </ul>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="showResultsModal = false"
                    >
                      Fermer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <!-- PARTIE CENTRALE CHARGES DE COMPTE -->

      <div id="groscontainer">
        <div id="centercontainer">
          <b-row align-self="center">
            <b-col align-self="center">
              <b-row>
                <b-col />

                <b-col />
              </b-row>
              <b-row>
                <b-col>
                  <b-row>
                    <b-col />

                    <b-col />
                  </b-row>

                  <!-- RECHERCHE ET NBR UTILISATEUR -->
                  <div
                    id="dheader"
                    class="d-flex align-items-center justify-content-center"
                  >
                    <div id="search-wrapper">
                      <span><b-icon icon="search"></b-icon></span>
                      <b-form-group label-for="filterInput">
                        <b-form-input
                          class="inputsearch"
                          v-model="userTable.model.filter"
                          type="search"
                          id="filterInput"
                          placeholder="Rechercher"
                        >
                        </b-form-input>
                      </b-form-group>
                    </div>
                  </div>

                  <!-- TABLEAU -->
                  <b-container class="taille" fluid="lg">
                    <b-row>
                      <b-col cols="12" align-self="center">
                        <b-table
                          id="tablo"
                          class="tableau table table-bordered"
                          fixed
                          responsive
                          sticky-header
                          :items="filters.users.model"
                          :fields="userTable.model.fields"
                          :current-page="userTable.model.currentPage"
                          :per-page="userTable.model.perPage"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :filter="userTable.model.filter"
                          :tbody-tr-class="rowClass"
                          @filtered="onFiltered"
                        >
                          <template fixed responsive sticky-header #thead-top>
                            <b-tr
                              id="testheader"
                              fixed
                              responsive
                              sticky-header
                            >
                              <b-th><h4>Chargés de comptes</h4></b-th>
                              <b-th
                                >({{ userTable.model.totalRows }} utilisateurs
                                trouvés)</b-th
                              >
                              <b-th
                                ><b-button
                                  class="btnligne"
                                  @click="toggleAllUsers"
                                  variant="primary"
                                  >{{
                                    filters.users.model.length !==
                                    filters.users.selected.length
                                      ? "Tout sélectionner"
                                      : "Déselectionner"
                                  }}</b-button
                                ></b-th
                              >
                            </b-tr>
                          </template>

                          <template v-slot:cell(selection)="row">
                            <b-form-checkbox
                              v-model="row.item.selected"
                              @change="selectUser(row)"
                            ></b-form-checkbox>
                          </template>

                          <template v-slot:cell(IsActive)="row">
                            <div v-if="row.value">
                              <b-icon
                                variant="success"
                                icon="circle-fill"
                              ></b-icon>
                            </div>

                            <div v-else>
                              <b-icon
                                variant="danger"
                                icon="circle-fill"
                              ></b-icon>
                            </div>
                          </template>
                        </b-table>
                      </b-col>
                    </b-row>
                  </b-container>

                  <div class="d-flex justify-content-between" id="incluresite">
                    <b-checkbox v-model="filters.mustHaveChargeAffaires"
                      >Inclure les sites sans chargé d'affaires</b-checkbox
                    >
                    <b-checkbox
                      @change="ToggleInactive"
                      v-model="inactiveSelect"
                      >{{ inactiveSelect ? "Retirer" : "Afficher" }} les
                      utilisateurs inactifs</b-checkbox
                    >

                    <div class="ml-3" v-if="sites.all.length >= 1">
                      <b>Résultats de la recherche : </b>
                      {{ sites.all.length }}
                      <span v-if="sites.all.length >= 2">
                        sites trouvés (
                        {{ sites.geolocalized.length }}
                        <span v-if="sites.geolocalized.length >= 2">
                          sites géolocalisés
                        </span>
                        <span v-else> site géolocalisé </span>
                        ,
                        {{ sites.notFound.length }}
                        <span v-if="sites.notFound.length >= 2">
                          sites non géolocalisables
                        </span>
                        <span v-else> site non géolocalisable </span>
                        )
                      </span>
                      <span v-else> site trouvé </span>
                    </div>
                  </div>

                  <b-row>
                    <b-col />

                    <b-col />
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>
      <br />

      <!-- DEBUT DES FILTRES -->

      <div id="container-filtre">
        <b-container fluid id="lignebtn" class="d-flex">
          <b-row no-gutters id="btnn">
            <div class="d-flex taillebtn">
              <b-col cols="6" md="6" lg="3" xl="6"
                ><b-checkbox v-model="filters.mustHaveType"
                  >Inclure les sites sans type</b-checkbox
                ></b-col
              >
              <b-col cols="6" md="6" lg="3" xl="6"
                ><b-checkbox v-model="filters.mustHaveTypology"
                  >Inclure les sites sans typologie</b-checkbox
                ></b-col
              >
            </div>

            <div class="d-flex justify-content-end taillebtn">
              <b-col lg="3" cols="4" xl="3"
                ><b-button class="btnligne" @click="resetAll"
                  >Réinitialiser la séléction</b-button
                ></b-col
              >
              <b-col lg="3" cols="4" xl="3"
                ><b-button
                  class="btnligne"
                  :disabled="!sites.geolocalized.length >= 1"
                  @click="openLastInstance"
                  >Ouvrir la dernière instance</b-button
                ></b-col
              >
              <b-col lg="3" cols="4" xl="3">
                <b-button class="btnligne" @click="getAndProcessSites"
                  >Chercher les sites</b-button
                ></b-col
              >
            </div>
          </b-row>
          <br />
        </b-container>

        <br />
        <br />

        <div id="filtre" class="">
          <b-container fluid id="boitebox">
            <!-- premiere boite -->

            <b-row id="lignebox">
              <b-col
                sm="5"
                md="5"
                lg="2"
                class="
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                  boite
                  m-1
                "
              >
                <br />
                <h6 class="d-flex align-items-center">Type du client</h6>

                <b-form-group>
                  <b-form-checkbox
                    class="checkboxx"
                    v-for="type in filters.types.model"
                    :key="type"
                    v-model="filters.types.selected"
                    :value="type"
                    >{{ type }}
                  </b-form-checkbox>
                </b-form-group>

                <br />
                <b-form-group class="select">
                  <b-form-checkbox
                    v-model="allSelectedTypes"
                    @change="ToggleAll($event, 'types')"
                  >
                    {{
                      allSelectedTypes ? "Désélectionner" : "Tout sélectionner"
                    }}
                  </b-form-checkbox>
                  <br />
                </b-form-group>
              </b-col>

              <!-- deuxieme boite -->

              <b-col
                sm="5"
                md="5"
                lg="2"
                class="
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                  boite
                  m-1
                "
              >
                <br />
                <h6 class="d-flex align-items-center">Typologie</h6>

                <b-form-group class="scroll border-right">
                  <b-form-checkbox
                    class="checkboxx"
                    v-for="typology in filters.typologies.model"
                    :key="typology"
                    v-model="filters.typologies.selected"
                    :value="typology"
                    >{{ typology }}
                  </b-form-checkbox>
                </b-form-group>

                <br />
                <b-form-group class="select">
                  <b-form-checkbox
                    v-model="allSelectedTypologies"
                    @change="ToggleAll($event, 'typologies')"
                  >
                    {{
                      allSelectedTypologies
                        ? "Désélectionner"
                        : "Tout sélectionner"
                    }}
                  </b-form-checkbox>
                  <br />
                </b-form-group>
              </b-col>

              <!-- troisième boite -->

              <b-col
                sm="5"
                md="5"
                lg="2"
                class="
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                  boite
                  m-1
                "
              >
                <br />
                <h6 class="d-flex align-items-center">Département</h6>

                <b-form-group class="scroll border-right">
                  <b-form-checkbox
                    class="checkboxx"
                    v-for="departement in filters.departements.model"
                    :key="departement.code"
                    v-model="filters.departements.selected"
                    :value="departement"
                    >{{ departement.text }}
                  </b-form-checkbox>
                </b-form-group>

                <br />
                <b-form-group class="select">
                  <b-form-checkbox
                    v-model="allSelectedDepartements"
                    @change="ToggleAll($event, 'departements')"
                  >
                    {{
                      allSelectedDepartements
                        ? "Désélectionner"
                        : "Tout sélectionner"
                    }}
                  </b-form-checkbox>
                  <br />
                </b-form-group>
              </b-col>

              <!-- quatrième boite -->

              <b-col
                sm="5"
                md="5"
                lg="2"
                class="
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                  boite
                  m-1
                "
              >
                <br />
                <h6 class="d-flex align-items-center">Région</h6>

                <b-form-group class="scroll border-right">
                  <b-form-checkbox
                    class="checkboxx"
                    @change="addDepartementsOfRegion($event)"
                    v-for="region in filters.regions.model"
                    :key="region.code"
                    v-model="filters.regions.selected"
                    :value="region"
                    >{{ region.text }}
                  </b-form-checkbox>
                </b-form-group>

                <br />

                <b-form-group class="select">
                  <b-form-checkbox
                    v-model="allSelectedRegions"
                    @change="ToggleAll($event, 'regions')"
                  >
                    {{
                      allSelectedRegions
                        ? "Désélectionner"
                        : "Tout sélectionner"
                    }}
                  </b-form-checkbox>
                  <br />
                </b-form-group>
              </b-col>

              <!-- cinquième boite -->

              <b-col
                sm="5"
                md="5"
                lg="2"
                class="
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                  boite
                  m-1
                "
              >
                <br />
                <h6 class="d-flex align-items-center">Région C2i santé</h6>

                <b-form-group class="scroll border-right">
                  <b-form-checkbox
                    class="checkboxx"
                    @change="addDepartementsOfRegionSF($event)"
                    v-for="regionSF in filters.regionsSF.model"
                    :key="regionSF.name"
                    v-model="filters.regionsSF.selected"
                    :value="regionSF"
                    >{{ regionSF.text }}
                  </b-form-checkbox>
                </b-form-group>

                <br />

                <b-form-group class="select">
                  <b-form-checkbox
                    v-model="allSelectedRegionsSF"
                    @change="ToggleAll($event, 'regionsSF')"
                  >
                    {{
                      allSelectedRegionsSF
                        ? "Désélectionner"
                        : "Tout sélectionner"
                    }}
                  </b-form-checkbox>
                  <br />
                </b-form-group>
              </b-col>
            </b-row>
          </b-container>
          <br />
          <br />
        </div>
      </div>
    </div>
    <div v-else>
      <Loading
        class="mt-4 text-center"
        :loading-circle="true"
        :max="this.sites.all.length"
        :progress="this.sites.geolocalized.length + this.sites.notFound.length"
        :loading-text-percentage="querying && this.sites.all.length >= 1"
        :progress-bar="querying && this.sites.all.length >= 1"
      />
      <div v-if="cancelling">
        <b-alert variant="warning" class="text-center" :show="true"
          ><b>Annulation en cours ...</b></b-alert
        >
      </div>
      <div class="mt-4 text-center" v-if="!cancelling && querying">
        <b-button variant="danger" @click="cancelAxiosQuery"
          >Annuler l'opération en cours</b-button
        >
      </div>
    </div>
  </div>
</template>



<script>
import axios from "axios";
import { latLng } from "leaflet";
import { mapGetters } from "vuex";

import Loading from "./Loading";
import * as turf from "@turf/turf";
let _ = require("lodash");

export default {
  name: "UsersAndFilters",
  components: { Loading },
  props: {
    salesforceBaseUrl: {
      type: String,
      default: process.env.VUE_APP_SALESFORCE_API_BASE_URL,
    },
    salesforceAccountPrefix: {
      type: String,
      default: process.env.VUE_APP_SALESFORCE_API_ACCOUNT_PREFIX,
    },
    salesforceAccountSuffix: {
      type: String,
      default: process.env.VUE_APP_SALESFORCE_API_ACCOUNT_SUFFIX,
    },
  },
  data() {
    return {
      sortBy: "Name",
      sortDesc: false,
      salesforceAccessToken: "",
      salesforceInstanceUrl: "",
      showResultsModal: false,
      salesforceQueryHeader: null,
      allSelectedTypes: false,
      allSelectedTypologies: false,
      allSelectedDepartements: false,
      allSelectedRegions: false,
      allSelectedRegionsSF: false,
      inactiveSelect: false,
      salesforceEnpoint: {
        describe: "/services/data/v48.0/sobjects/",
        queryAll: "/services/data/v48.0/queryAll/",
      },
      salesforceAccountFields:
        "Name, " +
        "Id, " +
        "ShippingAddress, " +
        "Charge_de_compte__c, " +
        "Charge_de_compte__r.Name, " +
        "L_Commercial_Terrain__c, " +
        "L_Commercial_Terrain__r.Name, " +
        "L_Chef_Secteur__c, " +
        "Type, " +
        "Latitude__c, " +
        "Longitude__c, " +
        "Sum_amount_won_opportunities__c, " +
        "Number_of_won_opportunities__c, " +
        "Typologie__c, " +
        "Client_Contrat__c ",
      // TODO-1-1
      // TODO-2-1
      // TODO-3-1
      axiosCancelSource: axios.CancelToken.source(),
      isInit: true,
      loading: false,
      cancelling: false,
      querying: false,
      userTable: {
        model: {
          totalRows: 0,
          currentPage: 1,
          filter: null,
          bordered: true,

          fields: [
            {
              key: "Name",
              label: "Utilisateurs (chargés de comptes)",
              sortable: true,
              sortDirection: "desc",
            },

            { key: "IsActive", label: "Statut", sortable: true },
            { key: "selection", label: "Sélection", sortable: false },
          ],
        },
        selected: {
          currentPage: 1,
          filter: null,

          fields: [
            {
              key: "Name",
              label: "Utilisateurs sélectionnés",
              sortable: true,
              sortDirection: "desc",
            },

            { key: "IsActive", label: "Statut", sortable: true },
            { key: "deselection", label: "Déselection", sortable: false },
          ],
        },
      },
      notFoundTable: {
        currentPage: 1,
        perPage: 3,
        fields: [
          {
            key: "Name",
            label: "Nom du site",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "salesforceLink",
            label: "Lien vers Salesforce",
            sortable: false,
          },
        ],
      },
      filters: {
        mustHaveChargeAffaires: false,
        mustHaveType: false,
        mustHaveTypology: false,
        users: {
          model: [],
          selected: [],
          api: "Charge_de_compte__c",
        },
        types: {
          model: [],
          selected: [],
          api: "Type",
        },
        typologies: {
          model: [],
          selected: [],
          api: "Typologie__c",
        },
        departements: {
          model: [],
          selected: [],
          api: "ShippingPostalCode",
        },
        regions: {
          model: [],
          selected: [],
        },
        regionsSF: {
          model: [],
          selected: [],
        },
      },
      sites: {
        all: [],
        geolocalized: [],
        notFound: [],
      },
      departementsSF: [],
    };
  },
  async mounted() {
    this.loading = true;
    this.salesforceAccessToken = this.$store.getters.salesforceAccessToken;
    this.salesforceInstanceUrl = this.$store.getters.salesforceInstanceUrl;

    await this.$nextTick(async () => {
      this.salesforceQueryHeader = {
        Accept: "application/json",
        Authorization: "Bearer " + this.salesforceAccessToken,
      };

      this.$store.commit("unstoreAllGeoJson");
      await this.initImportedFiles();
      await this.initUsersTable();
      this.filters.types.model = await this.initFilterModel(
        this.filters.types.api
      );
      this.filters.typologies.model = await this.initFilterModel(
        this.filters.typologies.api
      );
      await this.initDepartementsFilter();
      await this.initRegionsFilter();
      await this.initRegionsSFFilter();
    });
    this.loading = false;
  },
  methods: {
    resetData() {
      this.axiosCancelSource = axios.CancelToken.source();
      this.isInit = true;
      this.loading = false;
      this.cancelling = false;
      this.querying = false;
      this.sites.all = [];
      this.sites.geolocalized = [];
      this.sites.notFound = [];
    },
    ToggleInactive(item) {
      if (item.IsActive === false) return "table-light";
    },
    ToggleAll(checked, filtre) {
      switch (filtre) {
        case "types":
          if (checked) {
            this.copyTable(
              this.filters.types.model,
              this.filters.types.selected
            );
          } else {
            this.resetTypeFilters();
          }

          break;

        case "typologies":
          if (checked) {
            this.copyTable(
              this.filters.typologies.model,
              this.filters.typologies.selected
            );
          } else {
            this.resetTypologyFilters();
          }
          break;

        case "departements":
          if (checked) {
            this.copyTable(
              this.filters.departements.model,
              this.filters.departements.selected
            );
          } else {
            this.resetDepartementFilters();
          }
          break;

        case "regions":
          if (checked) {
            this.copyTable(
              this.filters.regions.model,
              this.filters.regions.selected
            );
            this.addDepartementsOfRegion(this.filters.regions.selected);
          } else {
            this.resetRegionFilters();
          }
          break;
        case "regionsSF":
          if (checked) {
            this.copyTable(
              this.filters.regionsSF.model,
              this.filters.regionsSF.selected
            );
            this.addDepartementsOfRegionSF(this.filters.regionsSF.selected);
          } else {
            this.resetRegionSFFilters();
          }
      }
    },

    async initImportedFiles() {
      await this.$store.dispatch("storeGeoJsonDepartements");
      await this.$store.dispatch("storeGeoJsonRegions");
    },
    async initUsersTable() {
      this.filters.users.model = await this.getUsers(this.filters.users.api);
      for (let user of this.filters.users.model) {
        user.selected = false;
      }
      this.userTable.model.totalRows = this.filters.users.model.length;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.IsActive === false) return "d-none"; // ICI POUR AFFICHER OU NON LES UTILISATEURS INACTIFS, POUR MASQUER METTRE D-NONE
      if (item.IsActive === true) return " table-light";
    },
    async initFilterModel(api) {
      let response = await this.axiosSalesforceRequestFactory(
        "describe",
        "Account"
      );
      let fields = response.data.fields;
      let index = null;

      for (let i = 0; i < fields.length; i++) {
        if (fields[i].name === api) {
          index = i;
        }
      }

      if (index != null) {
        let list = fields[index].picklistValues;

        let array = [];
        list.forEach((element) => {
          array.push(element.value);
        });
        return array;
      }
    },
    async initDepartementsFilter() {
      this.departementsSF = await this.getDepartementsSF();

      for (let departement of this.geoJsonDepartements.features) {
        let departementModel = {
          text:
            departement.properties.code + " - " + departement.properties.nom,
          name: departement.properties.nom,
          code: departement.properties.code,
        };

        let corrDepartementSF = this.departementsSF.find(
          (el) => el.Name === departementModel.code
        );
        if (corrDepartementSF) {
          if (corrDepartementSF.Charge_compte__c) {
            departementModel.charge_de_compte =
              corrDepartementSF.Charge_compte__c;
          }
        }
        this.filters.departements.model.push(departementModel);
      }
    },
    async initRegionsFilter() {
      let header = {
        Accept: "application/json",
      };

      for (let region of this.geoJsonRegions.features) {
        let c = region.properties.code;
        let response = await axios.get(
          "https://geo.api.gouv.fr/regions/" + c + "/departements",
          { headers: header }
        );
        this.filters.regions.model.push({
          text: region.properties.code + " - " + region.properties.nom,
          name: region.properties.nom,
          code: region.properties.code,
          departements: _.map(response.data, "code"),
        });
      }
    },
    async initRegionsSFFilter() {
      let regionsSF = _.uniq(
        _(this.departementsSF).map("Region_C2i_sante__r").map("Name").value()
      );
      let regionsSFModel = [];
      for (let regionSF of regionsSF) {
        if (regionSF) {
          let departementsSFFromRegion = [];
          for (let departementSF of this.departementsSF) {
            if (departementSF.Region_C2i_sante__r) {
              if (departementSF.Region_C2i_sante__r.Name) {
                if (departementSF.Region_C2i_sante__r?.Name === regionSF) {
                  departementsSFFromRegion.push(departementSF);
                }
              }
            }
          }

          let corrDepartementsSF = _.map(departementsSFFromRegion, "Name");

          let nombreChargeAffairesObjectif = 0;
          if (departementsSFFromRegion) {
            if (departementsSFFromRegion[0].Region_C2i_sante__r) {
              if (
                departementsSFFromRegion[0].Region_C2i_sante__r
                  .Nombre_de_charge_de_comptes__c
              ) {
                nombreChargeAffairesObjectif =
                  departementsSFFromRegion[0].Region_C2i_sante__r
                    .Nombre_de_charge_de_comptes__c;
              }
            }
          }

          let model = {
            text: regionSF,
            name: regionSF,
            departements: corrDepartementsSF,
            nombreChargeAffairesObjectif: nombreChargeAffairesObjectif,
          };
          regionsSFModel.push(model);
        }
      }

      this.filters.regionsSF.model = regionsSFModel;
    },
    addDepartementsOfRegion(regions) {
      if (regions) {
        for (let region of regions) {
          for (let departement of region.departements) {
            // Récupérer le département FR
            let corrDepartement = this.filters.departements.model.find(
              (el) => el.code === departement
            );
            if (corrDepartement) {
              // Si département pas déjà sélectionné
              if (
                !_.map(this.filters.departements.selected, "code").includes(
                  corrDepartement.code
                )
              ) {
                // Ajouter le département à la sélection
                this.filters.departements.selected.push(corrDepartement);
              }
            }
          }
        }
      }
    },
    addDepartementsOfRegionSF(regionsSF) {
      if (regionsSF) {
        for (let regionSF of regionsSF) {
          for (let departement of regionSF.departements) {
            // Récupérer le département FR
            let corrDepartement = this.filters.departements.model.find(
              (el) => el.code === departement
            );
            if (corrDepartement) {
              // Si département pas déjà sélectionné
              if (
                !_.map(this.filters.departements.selected, "code").includes(
                  corrDepartement.code
                )
              ) {
                // Ajouter le département à la sélection
                this.filters.departements.selected.push(corrDepartement);
              }
            }
          }
        }
      }
    },
    async getUsers(api) {
      let query =
        "?q=SELECT Name, Id, IsActive FROM User WHERE Id IN (SELECT " +
        api +
        " FROM ACCOUNT)";
      return await this.axiosSalesforceRequestFactory("queryAll", query);
    },
    resetAll() {
      this.resetData();
      this.resetUserFilters();
      this.resetTypeFilters();
      this.resetTypologyFilters();
      this.resetDepartementFilters();
      this.resetRegionFilters();
      this.resetRegionSFFilters();
    },
    toggleAllUsers() {
      if (
        this.filters.users.model.length !== this.filters.users.selected.length
      ) {
        this.selectAllUsers();
      } else {
        this.deselectAllUsers();
      }
    },
    selectAllUsers() {
      for (let user of this.filters.users.model) {
        user.selected = true;
      }
      this.copyTable(this.filters.users.model, this.filters.users.selected);
    },
    deselectAllUsers() {
      for (let user of this.filters.users.model) {
        user.selected = false;
      }
      this.filters.users.selected = [];
    },
    copyTable(source, destination) {
      for (let el of source) {
        if (!destination.includes(el)) {
          destination.push(el);
        }
      }
    },
    resetUserFilters() {
      this.filters.users.selected = [];
    },
    resetTypeFilters() {
      this.filters.types.selected = [];
    },
    resetTypologyFilters() {
      this.filters.typologies.selected = [];
    },
    resetDepartementFilters() {
      this.filters.departements.selected = [];
    },
    resetRegionFilters() {
      this.filters.regions.selected = [];
    },
    resetRegionSFFilters() {
      this.filters.regionsSF.selected = [];
    },
    onFiltered(filteredItems) {
      this.userTable.model.totalRows = filteredItems.length;
      this.userTable.currentPage = 1;
    },
    selectUser(user) {
      if (!this.filters.users.selected.includes(user.item)) {
        this.filters.users.selected.push(user.item);
      } else {
        const index = this.filters.users.selected.indexOf(user.item);
        if (index > -1) {
          this.filters.users.selected.splice(index, 1);
        }
      }
      this.userTable.selected.totalRows = this.filters.users.selected.length;
    },
    deselectUser(user) {
      const index = this.filters.users.selected.indexOf(user.item);
      if (index > -1) {
        this.filters.users.selected.splice(index, 1);
      }
    },
    goToSalesforceSite(site) {
      if (site !== "" && site !== null) {
        let url =
          this.salesforceBaseUrl +
          this.salesforceAccountPrefix +
          site.item.Id +
          "/" +
          this.salesforceAccountSuffix;
        window.open(url, "_blank");
      }
    },
    async getAndProcessSites() {
      this.resetData();
      this.isInit = false;
      this.loading = true;
      this.querying = true;
      await this.getSites();
      await this.processSitesGeolocalisation();
      this.querying = false;
      this.setDepartementAttributes();
      this.setRegionAttributes();
      this.setRegionSFAttributes();
      this.$store.commit("storeMarkers", this.sites.geolocalized);
      this.$store.commit(
        "setGeoJsonMarkers",
        this.createPolygonFromMarkers(this.sites.geolocalized)
      );
      this.$store.commit(
        "setGeoJsonUsers",
        this.createGeoJsonFeatureCollection(
          this.setFilterWithSites(
            this.sites.geolocalized,
            "CA",
            "Aucun chargé d'affaires"
          )
        )
      );
      this.$store.commit(
        "setGeoJsonTypes",
        this.createGeoJsonFeatureCollection(
          this.setFilterWithSites(this.sites.geolocalized, "type", "Aucun type")
        )
      );
      this.$store.commit(
        "setGeoJsonTypologies",
        this.createGeoJsonFeatureCollection(
          this.setFilterWithSites(
            this.sites.geolocalized,
            "typology",
            "Aucune typologie"
          )
        )
      );
      this.showResultsModal = true;
      this.loading = false;

      this.openLastInstance();
    },
    openLastInstance() {
      if (this.sites.geolocalized.length >= 1) {
        let routeData = this.$router.resolve({ name: "map" });
        window.open(routeData.href, "_blank");
      }
    },
    // TODO-1-2: getChiffreAffairesContrat()
    // TODO-2-2: getNPSMoyenSites()
    async getDepartementsSF() {
      let query =
        "?q=SELECT Id, Name, Region_C2i_sante__c, Region_C2i_sante__r.Name, Region_C2i_sante__r.Nombre_de_charge_de_comptes__c FROM Mapping_departement__c";
      return await this.axiosSalesforceRequestFactory("queryAll", query);
    },
    async getSites() {
      this.sites.all = await this.axiosSalesforceRequestFactory(
        "queryAll",
        this.filtersQuery
      );
    },
    async axiosSalesforceRequestFactory(queryService, query) {
      if (!this.cancelling) {
        let service = "";
        switch (queryService) {
          case "describe":
            service = this.salesforceEnpoint.describe;
            query += "/describe";
            break;
          case "queryAll":
            service = this.salesforceEnpoint.queryAll;
        }
        let url = this.salesforceInstanceUrl + service + query;
        let response = await axios
          .get(url, {
            headers: this.salesforceQueryHeader,
            cancelToken: this.axiosCancelSource.token,
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              this.cancelling = true;
              console.log("Cancelling request ...");
            } else {
              // handle error
            }
          });

        if (queryService === "describe") {
          return response;
        }

        let data = response.data?.records;

        while (!response.data?.done && !this.cancelling) {
          url = this.salesforceInstanceUrl + response.data.nextRecordsUrl;
          response = await axios
            .get(url, {
              headers: this.salesforceQueryHeader,
              cancelToken: this.axiosCancelSource.token,
            })
            .catch((thrown) => {
              if (axios.isCancel(thrown)) {
                this.cancelling = true;
                console.log("Cancelling request ...");
              } else {
                // handle error
              }
            });
          response.data.records.forEach((el) => {
            data.push(el);
          });
        }

        return data;
      }
    },
    cancelAxiosQuery() {
      this.axiosCancelSource.cancel("Opération annulée");
      this.cancelling = false;
      this.loading = false;
    },
    constructQueryFiltersOr(filtersSelected, api) {
      let query = "";
      if (filtersSelected.length >= 1) {
        query += "(";
        for (let filter of filtersSelected) {
          query += api + " LIKE '" + filter.substring(0, 2) + "%25' OR ";
        }
        query = query.slice(0, -4);
        query += ")";
      }
      return query;
    },
    constructQueryFiltersInWithSeparator(filtersSelected, api, separator) {
      let query = "";
      if (filtersSelected.length >= 1) {
        query = api + " IN (";
        for (let filter of filtersSelected) {
          query +=
            separator + this.handleSpecialCharacter(filter) + separator + ", ";
        }
        query = query.slice(0, -2);
        query += ")";
      }
      return query;
    },
    handleSpecialCharacter(text) {
      return text.replace(/'/g, "\\'");
    },
    async processSitesGeolocalisation() {
      for (let site of this.sites.all) {
        if (
          Object.prototype.hasOwnProperty.call(site, "Latitude__c") &&
          Object.prototype.hasOwnProperty.call(site, "Longitude__c")
        ) {
          if (site.Latitude__c !== "0" && site.Longitude__c !== "0") {
            if (Object.prototype.hasOwnProperty.call(site, "ShippingAddress")) {
              if (
                site.ShippingAddress !== null &&
                site.ShippingAddress !== undefined
              ) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    site.ShippingAddress,
                    "postalCode"
                  )
                ) {
                  if (
                    site.ShippingAddress.postalCode !== null &&
                    site.ShippingAddress.postalCode !== ""
                  ) {
                    let siteCoordinates = latLng(
                      site.Latitude__c,
                      site.Longitude__c
                    );
                    let marker = {
                      id: site.Id,
                      address: site.ShippingAddress,
                      coordinates: siteCoordinates,
                      text: site.Name,
                      CA: "Non trouvé", // Chargé de comptes
                      CT: "Non trouvé", // Commercial terrain
                      type: site.Type,
                      typology: site.Typologie__c,
                      reference: site.attributes.url,
                      abonne: site.Client_Contrat__c,
                      // TODO-1-3: Chiffre d'affaires contrats
                      // TODO-2-3: Moyenne des NPS (moyens ou non selon la méthode employée)
                      // TODO-3-2: Abonné ou non
                      chiffreAffaires: Math.round(
                        site.Sum_amount_won_opportunities__c
                      ),
                      nombreOpportunitesGagnees:
                        site.Number_of_won_opportunities__c,
                      departementFromPostalCode:
                        this.searchForDepartementFromCode(
                          site.ShippingAddress.postalCode
                        ),
                      showText: false,
                    };

                    if (site.Charge_de_compte__r !== null) {
                      marker.CA = site.Charge_de_compte__r.Name;
                    }
                    if (site.L_Commercial_Terrain__r !== null) {
                      marker.CT = site.L_Commercial_Terrain__r.Name;
                    }

                    this.sites.geolocalized.push(marker);
                  } else {
                    this.sites.notFound.push(site);
                  }
                } else {
                  this.sites.notFound.push(site);
                }
              } else {
                this.sites.notFound.push(site);
              }
            } else {
              this.sites.notFound.push(site);
            }
          } else {
            this.sites.notFound.push(site);
          }
        } else {
          this.sites.notFound.push(site);
        }
      }
    },
    searchForDepartementFromCode(sitePostalCode) {
      for (let departement of this.geoJsonDepartements.features) {
        if (
          sitePostalCode !== null &&
          sitePostalCode.substring(0, 2) === departement.properties.code
        ) {
          return {
            nom: departement.properties.nom,
            code: departement.properties.code,
          };
        }
      }
    },
    createGeoJsonFeatureCollection(features) {
      return { type: "FeatureCollection", features: features };
    },
    setDepartementAttributes() {
      let geoFeatures = this.geoJsonDepartements.features;
      for (let departement of geoFeatures) {
        departement.properties.sites = [];
        departement.properties.totalAmount = 0;
        departement.properties.nombreSites = 0;
        departement.properties.nombreOpportunitesGagnees = 0;
        departement.properties.moyenneTotalAmountNombreSites = 0;
        departement.properties.moyenneTotalAmountNombreOpportunites = 0;
        departement.properties.CA = [];
        departement.properties.nombreChargeAffaires = 0;
        departement.properties.nombreAbonne = 0;

        for (let marker of this.sites.geolocalized) {
          if (
            Object.prototype.hasOwnProperty.call(
              marker,
              "departementFromPostalCode"
            ) &&
            marker.departementFromPostalCode !== undefined
          ) {
            if (
              Object.prototype.hasOwnProperty.call(
                marker.departementFromPostalCode,
                "code"
              )
            ) {
              if (
                marker.departementFromPostalCode.code ===
                departement.properties.code
              ) {
                departement.properties.totalAmount += marker.chiffreAffaires;
                departement.properties.nombreSites += 1;
                departement.properties.nombreOpportunitesGagnees +=
                  marker.nombreOpportunitesGagnees;
                // TODO-1-4: Cumul chiffre d'affaires contrats
                // TODO-2-4: Moyenne des NPS moyens
                // TODO-3-3: Cumul abonnés
                if (marker.abonne === true) {
                  departement.properties.nombreAbonne += 1;
                }

                if (marker.CA) {
                  departement.properties.CA.push(marker.CA);
                }
              }
            }
          }
        }

        departement.properties.totalAmount = Math.round(
          departement.properties.totalAmount
        );

        if (departement.properties.totalAmount !== 0) {
          if (departement.properties.nombreSites !== 0) {
            departement.properties.moyenneTotalAmountNombreSites = Math.round(
              departement.properties.totalAmount /
                departement.properties.nombreSites
            );
          }
          if (departement.properties.nombreOpportunitesGagnees !== 0) {
            departement.properties.moyenneTotalAmountNombreOpportunites =
              Math.round(
                departement.properties.totalAmount /
                  departement.properties.nombreOpportunitesGagnees
              );
          }
        }
        if (departement.properties.CA) {
          departement.properties.nombreChargeAffaires = _.uniq(
            departement.properties.CA
          ).length;
        }
      }
      this.$store.commit(
        "setGeoJsonDepartements",
        this.createGeoJsonFeatureCollection(geoFeatures)
      );
    },
    setRegionAttributes() {
      let geoFeatures = this.geoJsonRegions.features;
      for (let region of geoFeatures) {
        region.properties.sites = [];
        region.properties.totalAmount = 0;
        region.properties.nombreSites = 0;
        region.properties.nombreOpportunitesGagnees = 0;
        region.properties.moyenneTotalAmountNombreSites = 0;
        region.properties.moyenneTotalAmountNombreOpportunites = 0;
        region.properties.CA = [];
        region.properties.nombreChargeAffaires = 0;
        region.properties.nombreAbonne = 0;

        let corrRegion = _.uniq(
          _.filter(this.filters.regions.model, { code: region.properties.code })
        );

        if (corrRegion.length >= 1) {
          let departementsOfRegion = corrRegion[0].departements;

          for (let departement of departementsOfRegion) {
            for (let corrDepartement of this.geoJsonDepartements.features) {
              if (corrDepartement.properties.code === departement) {
                region.properties.totalAmount +=
                  corrDepartement.properties.totalAmount;
                region.properties.nombreSites +=
                  corrDepartement.properties.nombreSites;
                region.properties.nombreOpportunitesGagnees +=
                  corrDepartement.properties.nombreOpportunitesGagnees;
                region.properties.moyenneTotalAmountNombreSites = Math.round(
                  region.properties.totalAmount / region.properties.nombreSites
                );
                region.properties.nombreAbonne +=
                  corrDepartement.properties.nombreAbonne;

                // TODO-1-5: Chiffre d'affaires contrats
                // TODO-2-5: Moyenne des NPS moyens
                // TODO-3-4: Cumul abonnés

                region.properties.moyenneTotalAmountNombreOpportunites =
                  Math.round(
                    region.properties.totalAmount /
                      region.properties.nombreOpportunitesGagnees
                  );

                if (corrDepartement.properties.CA) {
                  region.properties.CA.push(...corrDepartement.properties.CA);
                  region.properties.nombreChargeAffaires = _.uniq(
                    region.properties.CA
                  ).length;
                }
              }
            }
          }
        }
      }
      this.$store.commit(
        "setGeoJsonRegions",
        this.createGeoJsonFeatureCollection(geoFeatures)
      );
    },
    setRegionSFAttributes() {
      let geoFeatures = [];
      let regionsSF = this.filters.regionsSF.model;

      // Pour chaque région
      for (let regionSF of regionsSF) {
        let regionGeoFeature = {};
        regionGeoFeature.properties = {};
        regionGeoFeature.geometry = {};
        regionGeoFeature.type = "Feature";
        regionGeoFeature.geometry.type = "MultiPolygon";
        regionGeoFeature.geometry.coordinates = [];

        regionGeoFeature.properties.nom = regionSF.name;
        regionGeoFeature.properties.sites = [];
        regionGeoFeature.properties.totalAmount = 0;
        regionGeoFeature.properties.nombreSites = 0;
        regionGeoFeature.properties.nombreOpportunitesGagnees = 0;
        regionGeoFeature.properties.moyenneTotalAmountNombreSites = 0;
        regionGeoFeature.properties.moyenneTotalAmountNombreOpportunites = 0;
        regionGeoFeature.properties.CA = [];
        regionGeoFeature.properties.nombreChargeAffaires = 0;
        regionGeoFeature.properties.nombreChargeAffairesObjectif =
          regionSF.nombreChargeAffairesObjectif;
        regionGeoFeature.properties.nombreAbonne = 0;

        // Pour chaque département
        for (let departementOfRegion of regionSF.departements) {
          // Récupérer les features du département associé
          let departementOfRegionFeature =
            this.geoJsonDepartements.features.find(
              (el) => el.properties.code === departementOfRegion
            );
          if (departementOfRegionFeature) {
            // Ajouter les features du départements aux features de la région
            if (departementOfRegionFeature.geometry.type === "MultiPolygon") {
              // Pour chaque sous-polygone du département
              for (let polygon of departementOfRegionFeature.geometry
                .coordinates) {
                for (let subPolygon of polygon) {
                  // Fusionner le polygone avec la région
                  regionGeoFeature = turf.union(
                    regionGeoFeature,
                    turf.polygon([subPolygon])
                  );
                }
              }
            } else {
              // Fusionner le polygone avec la région
              regionGeoFeature = turf.union(
                regionGeoFeature,
                departementOfRegionFeature
              );
            }

            regionGeoFeature.properties.totalAmount +=
              departementOfRegionFeature.properties.totalAmount;
            // TODO-1-6: Chiffre d'affaires contrats
            // TODO-2-6: Moyenne des NPS moyens
            // TODO-3-5: Cumul abonnés
            regionGeoFeature.properties.nombreSites +=
              departementOfRegionFeature.properties.nombreSites;
            regionGeoFeature.properties.nombreOpportunitesGagnees +=
              departementOfRegionFeature.properties.nombreOpportunitesGagnees;
            regionGeoFeature.properties.moyenneTotalAmountNombreSites =
              Math.round(
                regionGeoFeature.properties.totalAmount /
                  regionGeoFeature.properties.nombreSites
              );
            regionGeoFeature.properties.moyenneTotalAmountNombreOpportunites =
              Math.round(
                regionGeoFeature.properties.totalAmount /
                  regionGeoFeature.properties.nombreOpportunitesGagnees
              );
            regionGeoFeature.properties.nombreAbonne +=
              departementOfRegionFeature.properties.nombreAbonne;

            if (departementOfRegionFeature.properties.CA) {
              regionGeoFeature.properties.CA.push(
                ...departementOfRegionFeature.properties.CA
              );
              regionGeoFeature.properties.nombreChargeAffaires = _.uniq(
                regionGeoFeature.properties.CA
              ).length;
            }
          }
        }

        geoFeatures.push(regionGeoFeature);
      }

      for (let regionFeature of geoFeatures) {
        regionFeature = turf.cleanCoords(regionFeature);
        regionFeature = turf.simplify(regionFeature);
      }

      this.$store.commit(
        "setGeoJsonRegionsSF",
        this.createGeoJsonFeatureCollection(geoFeatures)
      );
    },
    createPolygonFromMarkers(markers) {
      let allPoints = [];
      for (let marker of markers) {
        allPoints.push(
          turf.point([marker.coordinates.lng, marker.coordinates.lat])
        );
      }
      let pointsCollection = turf.featureCollection(allPoints);
      return turf.concave(pointsCollection, {});
    },
    setFilterWithSites(sites, keyProperty, textReplacement) {
      let allPoly = [];
      let allFilters = _.uniq(_.map(sites, keyProperty));

      for (let site of allFilters) {
        let sitesOfFilter = [];
        switch (keyProperty) {
          case "CA":
            sitesOfFilter = _.filter(sites, { CA: site });
            break;
          case "type":
            sitesOfFilter = _.filter(sites, { type: site });
            break;
          case "typology":
            sitesOfFilter = _.filter(sites, { typology: site });
            break;
          default:
            break;
        }
        let geoJsonPoly = null;

        if (sitesOfFilter.length >= 3) {
          geoJsonPoly = this.createPolygonFromMarkers(sitesOfFilter);
        } else if (sitesOfFilter.length === 2) {
          let p1 = [
            sitesOfFilter[0].coordinates.lng,
            sitesOfFilter[0].coordinates.lat,
          ];
          let p2 = [
            sitesOfFilter[1].coordinates.lng,
            sitesOfFilter[1].coordinates.lat,
          ];
          geoJsonPoly = turf.lineString([p1, p2]);
        } else if (sitesOfFilter.length === 1) {
          geoJsonPoly = turf.point([
            sitesOfFilter[0].coordinates.lng,
            sitesOfFilter[0].coordinates.lat,
          ]);
        }

        if (geoJsonPoly !== null) {
          if (site === undefined || site === null) {
            site = textReplacement;
          }

          let totalAmount = Math.round(
            _.sumBy(sitesOfFilter, "chiffreAffaires")
          );
          let nombreSites = sitesOfFilter.length;
          let nombreOpportunitesGagnees = _.sumBy(
            sitesOfFilter,
            "nombreOpportunitesGagnees"
          );
          let moyenneTotalAmountNombreSites = Math.round(
            totalAmount / nombreSites
          );
          let moyenneTotalAmountNombreOpportunites = Math.round(
            totalAmount / nombreOpportunitesGagnees
          );

          let nombreAbonne = sitesOfFilter.filter(
            (el) => el.abonne === true.length
          );

          // TODO-1-7
          // TODO-2-7
          // TODO-3-6

          let CA = [];
          let nombreChargeAffaires = 0;
          for (let site of sitesOfFilter) {
            CA.push(site.CA);
          }
          if (CA) {
            nombreChargeAffaires = _.uniq(CA).length;
          }

          geoJsonPoly.properties = {
            name: site,
            nombreAbonne: nombreAbonne,
            totalAmount: totalAmount,
            nombreSites: nombreSites,
            nombreOpportunitesGagnees: nombreOpportunitesGagnees,
            moyenneTotalAmountNombreSites: moyenneTotalAmountNombreSites,
            moyenneTotalAmountNombreOpportunites:
              moyenneTotalAmountNombreOpportunites,
            nombreChargeAffaires: nombreChargeAffaires,
          };
          allPoly.push(geoJsonPoly);
        }
      }
      return allPoly;
    },
  },
  computed: {
    ...mapGetters(["geoJsonDepartements", "geoJsonRegions"]),
    selectedUsersTotalRows() {
      return this.filters.users.selected.length;
    },
    filtersUserQuery() {
      return this.constructQueryFiltersInWithSeparator(
        _.map(this.filters.users.selected, "Id"),
        this.filters.users.api,
        "'"
      );
    },
    filtersTypeQuery() {
      return this.constructQueryFiltersInWithSeparator(
        this.filters.types.selected,
        this.filters.types.api,
        "'"
      );
    },
    filtersTypologyQuery() {
      return this.constructQueryFiltersInWithSeparator(
        this.filters.typologies.selected,
        this.filters.typologies.api,
        "'"
      );
    },
    filtersDepartementQuery() {
      return this.constructQueryFiltersOr(
        _.map(this.filters.departements.selected, "code"),
        this.filters.departements.api
      );
    },
    filtersQuery() {
      let query =
        "?q=SELECT " + this.salesforceAccountFields + "FROM Account WHERE ";
      for (let [key] of Object.entries(this.filters)) {
        let loadQuerry = "";
        switch (key) {
          case "users":
            loadQuerry = this.filtersUserQuery;
            break;
          case "types":
            loadQuerry = this.filtersTypeQuery;
            break;
          case "typologies":
            loadQuerry = this.filtersTypologyQuery;
            break;
          case "departements":
            loadQuerry = this.filtersDepartementQuery;
            break;
          default:
            break;
        }

        if (loadQuerry.length >= 1) {
          query += loadQuerry + " AND ";
        }
      }

      if (!this.filters.mustHaveChargeAffaires) {
        query += this.filters.users.api + " != null AND ";
      }

      if (!this.filters.mustHaveType) {
        query += this.filters.types.api + " != null AND ";
      }

      if (!this.filters.mustHaveTypology) {
        query += this.filters.typologies.api + " != null AND ";
      }

      if (query.length >= 1) {
        query = query.slice(0, -4);
      }
      return query;
    },
  },
};
</script>

<style scoped>
.scroll {
  max-height: 300px;
  overflow-y: auto;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.tableau {
  align-items: center;
  justify-content: center;

  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15), 0 2px 2px rgba(0, 0, 0, 0.15),
    0 4px 4px rgba(0, 0, 0, 0.15), 0 8px 8px rgba(0, 0, 0, 0.15);
}

tbody {
  text-align: center;
}

sticky-header {
  height: 200px;
}

#centercontainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

#utilisateur {
  font-weight: bold;
}

#filterInput {
  border-radius: 50px;
}

#incluresite {
  font-weight: bold;
}
#groscontainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-image: url("./../assets/engrenage.png");
  background-repeat: no-repeat;
  background-position: right 45%;
}

#container-filtre {
  align-items: center;
  justify-content: center;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.boite {
  background-color: #009de0;
  margin: 0;
}

.checkboxx {
  background-color: white;
  border-radius: 5px;
  margin-top: 1rem;
  margin-right: 5px;
}

.select {
  height: auto;

  color: white;
}

.custom-control {
  padding-left: 2rem !important;
}

h6 {
  color: white;
}

#lignebtn {
  width: 100%;
  margin: 0 !important;
}

#btnn {
  width: 100% !important;
}

#box {
  width: 100% !important;
}

#boitebox {
  width: 100% !important;
  margin: 0 !important;
}

#lignebox {
  width: 100%;
  margin: 0 !important;
  align-items: center;
  justify-content: space-between;
}

#boitefiltre {
  width: 100%;
}

#filtre {
  width: 100%;
  margin: auto;
}

.btnligne {
  border-radius: 10px;
  font-size: 0.9rem;
  background-color: #009de0;
  border: none;
}

fieldset {
  height: 20vh;
  width: 90%;
}

#search-wrapper {
  border: 1px solid #ccc;

  height: 30px;
  display: flex;
  align-items: center;
}

#search-wrapper span {
  display: inline-block;
  padding: 0rem 1rem;
  font-size: 1.5rem;
}

#search-wrapper div {
  display: flex;
  align-items: center;
  height: 30px;
}

#search-wrapper,
.inputsearch {
  height: 100%;
  padding: 0.5rem;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
}

#filterInput {
  display: flex;
  align-items: center !important;
  justify-content: center;
}

.inputsearch {
  align-items: center;
  height: 30px;
}

#dheader {
  width: 100%;
  height: 65px;
  margin-top: 30px;
}

#titreheader {
  margin-top: 25px;
}

.form-group {
  margin-bottom: 0 !important;
}

h4 {
  font-weight: bold;
}

#testheader th {
  position: sticky;
  border-collapse: collapse;
}

.taille {
  width: 100% !important;
}

.taillebtn {
  width: 50%;
}

@media screen and (max-width: 480px) {
  .taillebtn {
    width: 100%;
    display: flex !important;
    justify-content: center !important;
    margin: 0 !important;
  }
}
</style>